<template>
  <div>
    <equipment-filters :users="users" :tags="tags" @apply="applyFilters"></equipment-filters>

    <b-card>
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Numer</th>
            <th>Numer faktury</th>
            <th>Data nabycia</th>
            <th>Nazwa wyposażenia</th>
            <th>
              <b-btn
                size="sm"
                variant="outline-secondary"
                class="float-right"
                @click="showAddEquipmentModal"
              >Dodaj</b-btn>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in equipment" :key="item.id">
            <td>{{ item.systemNumber }}</td>
            <td>{{ item.invoiceNumber }}</td>
            <td>{{ item.dateOfPurchase }}</td>
            <td>
              <b-container fluid>
                <b-row>{{ item.name }}</b-row>
                <b-row class="detail-sm">
                  <font-awesome-icon icon="user" class="mr-2 mt-1 mr-sm-2 mt-sm-1"></font-awesome-icon>
                  {{ item.user ? item.user.firstName + ' ' + item.user.lastName : 'Brak' }}
                  <b-btn
                    class="btn-xs"
                    @click="
                      selectedItem = item;
                      item.user ? (selectedUser.value = item.user.id) : (selectedUser.value = null);
                      item.user ? (selectedUser.text = item.user.firstName + ' ' + item.user.lastName) : (selectedUser.text = '');
                      chooseUserModal = true;
                    "
                  >Zmień</b-btn>
                </b-row>
                <b-row class="detail-sm">
                  <img
                    src="../../assets/tree_struct_white.png"
                    width="17"
                    height="17"
                    class="mr-1"
                    v-b-tooltip.hover
                    title="Pozycja w strukturze"
                  />
                  {{ structurePath(item) }}
                  <b-btn
                    v-b-tooltip.hover
                    title="Zmień pozycję w strukturze"
                    class="btn-xs"
                    @click="showTreeStructModal(item)"
                  >Zmień</b-btn>
                </b-row>
                <b-row class="detail-sm">
                  <span
                    v-for="tag in item.tags"
                    class="badge badge-secondary tag"
                    :style="'background-color:' + tagColors[tag.id]"
                    :key="tag.id"
                  >{{ tag.name }}</span>
                </b-row>
              </b-container>
            </td>
            <td class="text-right">
              <b-dropdown
                size="sm"
                split
                @click="
                  selectedItem = item;
                  isEdit = true;
                  modalShow = true;
                "
                text="Edytuj"
                variant="outline-primary"
              >
                <b-dropdown-item @click="removeAssignment(item.id)">Usuń przypisanie</b-dropdown-item>
                <b-dropdown-item @click="removeEquipment(item.id)">Usuń wyposażenie</b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination :value="page" :total-rows="total" :per-page="count" @change="changePage"></b-pagination>
      <modal
        v-if="modalShow"
        :addModal="modalShow"
        @cancel="hideModal"
        @add="itemAdded"
        @edited="itemEdited"
        :item="selectedItem"
        :isEdit="isEdit"
        :tags="tags"
      ></modal>
      <tree-struct
        v-if="treeStructShow"
        :show="treeStructShow"
        :item="selectedItem"
        @cancel="hideTreeStructModal"
        @tree="updateTreeStruct"
      ></tree-struct>
      <b-modal
        v-if="chooseUserModal"
        v-model="chooseUserModal"
        ok-title="Zapisz"
        cancel-title="Anuluj"
        ok-variant="outline-primary"
        cancel-variant="outline-secondary"
        hide-header
        @ok.prevent="assign"
        @hidden="hideChooseUserModal"
      >
        Przypisz sprzęt
        <b>{{ selectedItem ? selectedItem.name : 'nazwa wyposażenia' }}</b>
        <hr />
        <!-- {{selectedItem?selectedItem.user?selectedItem.user.id:null:null}} -->
        <b-form-group
          label="Pracownik"
          :state="stateUser"
          :invalid-feedback="invalidUser"
          :valid-feedback="validUser"
        >
          <v-select :value="selectedUser" @input="updateSelectedUser" label="text" :options="users"></v-select>
        </b-form-group>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment';
import modal from './modal.vue';
import treeStruct from './treeStruct.vue';
import equipmentFilters from './filters.vue';
import router from '@/router';
import { EquipmentResource } from '@/resources/equipment.resource';
import { UserResource } from '@/resources/user.resource';
import { LogicalStructureResource } from '@/resources/logicalStructure.resource';
import { TagResource } from '@/resources/tag.resource';
import tagService from '@/services/tag.service';
import filtersService from '@/services/filters.service';

export default {
  components: {
    modal,
    treeStruct,
    equipmentFilters
  },
  data() {
    const params = new URLSearchParams(window.location.search);
    let page = params.get('page');
    page = (page && +page) || 1;
    const count = 10;
    // glitch wymusza, żeby od początku były strony, żeby była zaznaczona wybrana strona
    const total = count * (page + 1);
    return {
      equipment: [],
      modalShow: false,
      selectedItem: null,
      chooseUserModal: false,
      users: [],
      selectedUser: { value: null, text: '' },
      isEdit: false,
      treeStructShow: false,
      paths: [],
      nodes: [],
      tags: [],
      tagColors: {},
      count,
      page,
      total,
      ISODateRegexp: /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/
    };
  },
  methods: {
    async getEquipment() {
      try {
        const equipmentList = await EquipmentResource.list((this.page - 1) * this.count, this.count, filtersService.queryToFilters(this.$route.query));
        this.$set(this, 'total', equipmentList.count);
        this.$set(this, 'equipment', equipmentList.equipment.map(item => this.formatItemDates(item)));
      } catch (error) {
        this.$notify({ type: 'error', text: 'Wystąpił błąd pobierania wyposażenia', title: 'Błąd' });
        console.warn(error);
      }
    },
    isIsoDate(str) {
      return this.ISODateRegexp.test(str) ? true : false;
    },
    formatItemDates(item) {
      if (this.isIsoDate(item.dateOfPurchase)) {
        item.dateOfPurchase = moment(new Date(item.dateOfPurchase)).format('DD.MM.YYYY');
      }
      if (item.deleteDate && this.isIsoDate(item.deleteDate)) {
        item.deleteDate = moment(new Date(item.deleteDate)).format('DD.MM.YYYY');
      }
      return item;
    },
    showAddEquipmentModal() {
      this.isEdit = false;
      this.modalShow = true;
    },
    hideModal() {
      this.modalShow = false;
      this.selectedItem = null;
    },
    itemAdded(item) {
      this.hideModal();
      this.equipment.push(this.formatItemDates(item));
    },
    itemEdited(item) {
      this.hideModal();
      this.$set(this.equipment, this.equipment.findIndex(eq => eq.id === item.equipmentUpdate.id), this.formatItemDates(item.equipmentUpdate));
    },
    async assign() {
      if (!this.selectedUser.value || !this.selectedItem.id) {
        this.$notify({ type: 'error', text: 'Problem z określeniem sprzętu lub pracownika', title: 'Błąd' });
        return;
      }
      try {
        const assignResult = await EquipmentResource.assign(this.selectedUser.value, this.selectedItem.id);
        this.$notify({ type: 'success', text: 'Pomyślnie przypisano przedmiot do użytkownika', title: 'Sukces' });
        this.$set(this.equipment.find(item => item.id === this.selectedItem.id), 'user', assignResult.user);
        this.hideChooseUserModal();
      } catch (error) {
        this.$notify({ type: 'error', text: 'Wystąpił błąd podczas przypisywania przedmiotu do użytkownika', title: 'Błąd' });
      }
    },
    async removeAssignment(id) {
      try {
        await EquipmentResource.removeAssignment(id);
        this.$set(this.equipment.find(item => item.id === id), 'user', null);
      } catch (error) {
        console.warn(error);
      }
    },
    hideChooseUserModal() {
      this.chooseUserModal = false;
      this.selectedItem = null;
    },
    updateSelectedUser(user) {
      this.selectedUser.value = user.value;
      this.selectedUser.text = user.text;
    },
    async getUsers() {
      try {
        const users = await UserResource.list();
        this.$set(this, 'users', users.map(user => ({ value: user.id, text: user.firstName + ' ' + user.lastName })));
      } catch (error) {
        console.warn(error);
      }
    },
    showTreeStructModal(item) {
      this.treeStructShow = true;
      this.selectedItem = item;
    },
    hideTreeStructModal() {
      this.treeStructShow = false;
      this.selectedItem = null;
    },
    updateTreeStruct(eq) {
      this.$set(this.equipment.find(e => e.id === eq.id), 'node', eq.node);
      this.hideTreeStructModal();
    },
    async getPaths() {
      const structure = await LogicalStructureResource.list();
      this.$set(this, 'nodes', structure);
      const roots = this.nodes.filter(x => x.parentId === null);
      roots.forEach(node => {
        this.paths.push({ id: node.id, path: node.name });
        this.setPath(node, node.name);
      });
    },
    setPath(prevNode, prevPath) {
      if (!prevNode || !prevNode.hasChildren) {
        return;
      }
      prevNode.children.forEach(children => {
        const node = this.nodes.find(n => n.id === children.id);
        const path = `${prevPath}/${node.name}`;
        this.paths.push({ id: node.id, path });
        this.setPath(node, path);
      });
    },
    async loadTags() {
      const tags = await TagResource.list();
      this.$set(this, 'tags', tags.map(tag => ({ value: tag.id, text: tag.name })));
      this.$set(this, 'tagColors', tagService.tagColors(tags));
    },
    changePage(page) {
      if (page) {
        router.replace({ name: 'equipment', query: { ...this.$route.query, page } });
        this.page = page;
        this.getEquipment();
      }
    },
    structurePath(item) {
      if (item.node && item.node.id) {
        const path = this.paths.find(p => p.id === item.node.id);
        if (path) {
          return path.path;
        }
      }
      return 'Brak';
    },
    applyFilters(filters) {
      router.replace({ name: 'equipment', query: { ...this.$route.query, ...filtersService.filtersToQuery(filters) } });
      this.getEquipment();
    },
    async removeEquipment(id) {
      try {
        if (!confirm('Czy napewno usunąć')) {
          return;
        }
        let data = await EquipmentResource.delete(id, (this.page - 1) * this.count, this.count, filtersService.queryToFilters(this.$route.query), this.page * this.count);
        data = parseInt(data.removeEquipment, 10);
        this.equipment.splice(this.equipment.findIndex(equipment => equipment.id === data), 1);
        this.$notify({ type: 'success', title: 'Sukces', text: 'Pomyślnie usunięto wyposażenie' });
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas usuwania' });
      }
    }
  },
  computed: {
    stateUser() {
      return this.selectedUser === null ? false : true;
    },
    invalidUser() {
      if (this.selectedUser === null) {
        return 'Wybierz pracownika';
      } else {
        return '';
      }
    },
    validUser() {
      return this.stateUser === true ? '' : '';
    }
  },
  beforeMount() {
    this.getPaths();
    this.getEquipment();
    this.getUsers();
    this.loadTags();
  }
};
</script>
<style>
.detail-sm {
  font-size: 0.9em;
  margin-top: 0.3em;
}
.btn-xs {
  font-size: 0.9em !important;
  padding: 0em 0.4em !important;
  margin: 0em 0.5em !important;
}
.tag {
  margin-left: 5px;
}
</style>
